module.exports = __webpack_public_path__ + "static/media/banner.ffc9b54e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/packaging-catalog/banner.jpg
// module id = 560
// module chunks = 0